import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import apiClient from '../../utils/axiosPetition';
import { useDataUser } from '../../context/dataUserContext';
import Contenedor from '../GlobalComponents/Contenedor';
import { ReactComponent as TableroControl } from "../../assets/icons/Tablero.svg";

ChartJS.register(ArcElement, Tooltip, Legend);

// Plugin personalizado para mostrar el total en el centro
const totalCenterTextPlugin = {
  id: 'totalCenterText',
  beforeDraw: (chart) => {
    const { ctx, chartArea: { width, height } } = chart;
    ctx.save();

    const total = chart.config.data.datasets[0].data.reduce((a, b) => a + b, 0);
    const fontSize = Math.min(width / 10, height / 10); // Ajustamos el tamaño de fuente con un límite
    ctx.font = `${fontSize}px sans-serif`;
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#333';

    const text = `Total: ${total}`;
    const textX = Math.round((width - ctx.measureText(text).width) / 2);
    const textY = (height + chart.chartArea.top) / 2 + 20;  // Centrar el texto correctamente

    ctx.fillText(text, textX, textY);
    ctx.restore();
  },
};

const GraficoUsuarios = () => {
  const [admins, setAdmins] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const { clinicId } = useDataUser();

  const fetchAdmins = async () => {
    try {
      const response = await apiClient.get(`/api/clinic/getAdmins/${clinicId}`);
      setAdmins(response.data);
    } catch (error) {
      console.error('Error al obtener administradores:', error);
    }
  };

  const fetchDoctors = async () => {
    try {
      const response = await apiClient.get(`/api/clinic/getDoctors/${clinicId}`);
      setDoctors(response.data);
    } catch (error) {
      console.error('Error al obtener doctores:', error);
    }
  };

  const fetchPatients = async () => {
    try {
      const response = await apiClient.get(`/api/clinic/getPatients/${clinicId}`);
      setPatients(response.data);
    } catch (error) {
      console.error('Error al obtener pacientes:', error);
    }
  };

  useEffect(() => {
    fetchAdmins();
    fetchDoctors();
    fetchPatients();
  }, []);

  const data = {
    labels: ['Administradores', 'Doctores', 'Pacientes'],
    datasets: [
      {
        label: 'Distribución de Usuarios',
        data: [admins.length, doctors.length, patients.length],
        backgroundColor: ['#205087ff', '#628cbdff', '#1f94c2ff'],
        hoverBackgroundColor: ['#205087ff', '#628cbdff', '#1f94c2ff'],
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          color: '#333',
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            return `${tooltipItem.label}: ${tooltipItem.raw} usuarios`;
          },
        },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <Contenedor icon={TableroControl} title={"Usuarios del sistema"} >
      <div className="flex items-center gap-9">
        <div className="flex flex-col w-fit gap-1">
          <span className="text-[#205087ff] font-bold">
            Administradores: <span className="text-[#70706eff]">{admins.length}</span>
          </span>
          <span className="text-[#628cbdff] font-bold">
            Doctores: <span className="text-[#70706eff]">{doctors.length}</span>
          </span>
          <span className="text-[#1f94c2ff] font-bold">
            Pacientes: <span className="text-[#70706eff]">{patients.length}</span>
          </span>
        </div>
        <div className="w-[300px] h-[300px]">
          <Doughnut data={data} options={options} plugins={[totalCenterTextPlugin]} />
        </div>
      </div>
    </Contenedor>
  );
};

export default GraficoUsuarios;
